import { IAgencyContactsModel } from '../Mock/MockModels';

export async function GetUserPreferences(agentId: string): Promise<any> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetUserPreferences`, {
      method: 'POST',
      body: new URLSearchParams({ agentId: agentId }),
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return '';
}

export async function DeleteUserPreferences(agentId: string): Promise<boolean> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/DeleteUserPreferences`, {
      method: 'POST',
      body: new URLSearchParams({ agentId: agentId }),
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: boolean = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return false;
}
export interface IClearA360SessionResponse {
  completed: boolean;
}
export async function ClearA360Session() {
  try {
    const res = await fetch(`/api/sitecore/UserInfo/ClearA360SessionCache`, {
      method: 'POST',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: IClearA360SessionResponse = await res.json();
        if (data?.completed !== null && data?.completed !== undefined) return data.completed;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return false;
}
export interface IClearA360SessionResponse {
  completed: boolean;
}
export async function ClearSession() {
  try {
    const res = await fetch(`/api/sitecore/UserInfo/EndUserSession`, {
      method: 'POST',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: IClearA360SessionResponse = await res.json();
        if (data?.completed !== null && data?.completed !== undefined) return data.completed;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return false;
}

export interface IServerInfoResponse {
  serverName: string;
}
export async function ServerInfo(): Promise<IServerInfoResponse | null> {
  try {
    const res = await fetch(`/api/sitecore/PortalSystemAsync/GetServerInfo`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: IServerInfoResponse = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return null;
}

export interface IMockerUserResponse {
  username: string;
  mock: boolean;
  error: string;
}
export async function MockUser(agentId: string, mocking: boolean): Promise<IMockerUserResponse | null> {
  try {
    const res = await fetch(`/api/sitecore/PortalUser/MockUser`, {
      method: 'POST',
      body: new URLSearchParams({ username: agentId, mock: mocking.toString() }),
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: IMockerUserResponse = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return null;
}
export interface ICanMockUserResponse {
  found: boolean;
  error: string;
}
export async function CanMockUser(agentId: string): Promise<ICanMockUserResponse | null> {
  try {
    const res = await fetch(`/api/sitecore/PortalUser/CanMockUser`, {
      method: 'POST',
      body: new URLSearchParams({ username: agentId }),
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: ICanMockUserResponse = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return null;
}
export async function GetAgentsByAgency(statCode: string): Promise<IAgencyContactsModel[]> {
  try {
    const res = await fetch(`/api/sitecore/AgencyAPIAsync/GetAgentsByAgency`, {
      method: 'POST',
      body: new URLSearchParams({ statCode: statCode }),
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: IAgencyContactsModel[] = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function GetUserSessionObjects(): Promise<string[][]> {
  try {
    const res = await fetch(`/api/sitecore/PortalUserAsync/GetUserSessionObjects`, {
      method: 'GET',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return [];
}

export async function LogoutUserAsync(): Promise<string | null> {
  try {
    const res = await fetch(`/api/sitecore/USCMAuthentication/LogOutUserAsync`, {
      method: 'POST',
    });
    if (res && res.headers) {
      const contentType = res.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        const data: any | null = await res.json();
        return data;
      }
    }
  } catch (error: any) {
    console.error(error);
  }
  return null;
}